import type React from "react";

import { ConfirmModal } from "@/components/ConfirmModal/ConfirmModal";
import { Stack } from "@/design-system/Stack";
import { useSessionUser } from "@/hooks/Network/useSessionUser";
import { servicePartnerMutations } from "@/queries/service-partners/mutations";
import { useTranslation } from "@/translations";

interface IqbiDetailsConsentModalProps {
  serviceId: string;
  isOpen: boolean;
  onClose: () => void;
}

export function IqbiDetailsConsentModal({ serviceId, isOpen, onClose }: IqbiDetailsConsentModalProps): React.ReactNode {
  const { t } = useTranslation();
  const sessionUser = useSessionUser();
  const giveConsentMutation = servicePartnerMutations.useGiveIqbiConsent();

  return (
    <ConfirmModal
      tone="primary"
      title={t("page.service-details.iqbi.consent-modal.title")}
      isLoading={giveConsentMutation.isPending}
      onResolve={() => {
        giveConsentMutation.mutate(serviceId);
        onClose();
      }}
      onReject={onClose}
      resolveBtnProps={{
        text: t("page.service-details.iqbi.consent-modal.confirm-btn"),
      }}
      rejectBtnProps={{
        text: t("page.service-details.iqbi.consent-modal.reject-btn"),
      }}
      onOpenChange={(state) => {
        if (!state) {
          onClose();
        }
      }}
      isOpened={isOpen}
    >
      <Stack gap="md">
        <p className="text-center">{t("page.service-details.iqbi.consent-modal.description")}</p>
        <p className="text-center">
          {sessionUser.address ? (
            <>
              {sessionUser.address.location}
              <br />
              {sessionUser.address?.postalCode} {sessionUser.address?.city}
            </>
          ) : (
            sessionUser.company?.name
          )}
        </p>
      </Stack>
    </ConfirmModal>
  );
}
